import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isAndroid } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.Frida
const label = visitFilterLabelMap[key]

export const fridaColumn = () =>
  columnHelper.display({
    id: 'frida',
    header: 'Frida Detected',
    cell: ({ row }) => {
      if (!isAndroid(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.frida

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
